import {
  Button as BootstrapButton,
  OverlayTrigger,
  Spinner,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
/**
 * @deprecated use components from shared/ui instead
 */
function Button({
  popover = null,
  isLoading = false,
  children = null,
  ...props
}) {
  const { t } = useTranslation("Shared");
  return popover ? (
    <OverlayTrigger overlay={popover} placement="top">
      <div>
        <BootstrapButton {...props}>
          {isLoading ? (
            <span style={{ whiteSpace: "nowrap" }}>
              <Spinner
                animation="border"
                variant="light"
                size="sm"
                className="d-inline-block me-2"
              />
              {t("loading")}
            </span>
          ) : (
            children
          )}
        </BootstrapButton>
      </div>
    </OverlayTrigger>
  ) : (
    <BootstrapButton {...props}>
      {isLoading ? (
        <span style={{ whiteSpace: "nowrap" }}>
          <Spinner
            animation="border"
            variant="light"
            size="sm"
            className="d-inline-block me-2"
          />
          {t("loading")}
        </span>
      ) : (
        children
      )}
    </BootstrapButton>
  );
}

export default Button;
